import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { MediaModalStyle } from "#next/components/modals/styles";
import { Dispatch, SetStateAction } from "react";

export const MediaModal = ({
  mediaModalIsOpen,
  setMediaModalIsOpen,
  mediaUrl,
}: {
  mediaModalIsOpen: boolean;
  setMediaModalIsOpen: Dispatch<SetStateAction<boolean>>;
  mediaUrl: string;
}) => {
  return (
    <Modal open={mediaModalIsOpen} onClose={() => setMediaModalIsOpen(false)}>
      <Box sx={MediaModalStyle}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            sx={{ maxHeight: "75vh", minWidth: "25vw" }}
            src={mediaUrl}
          />
        </Box>
      </Box>
    </Modal>
  );
};
